import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AddOfflineCardsToStockMutationVariables = Types.Exact<{
  amount: Types.Scalars['Int'];
}>;


export type AddOfflineCardsToStockMutation = { __typename?: 'Mutation', addOfflineCardsToStock: Array<{ __typename?: 'OfflineCard', user_id: string, signup_code: string, trackable_item_id: string }> };


export const AddOfflineCardsToStockDocument = gql`
    mutation AddOfflineCardsToStock($amount: Int!) {
  addOfflineCardsToStock(amount: $amount) {
    user_id
    signup_code
    trackable_item_id
  }
}
    `;
export type AddOfflineCardsToStockMutationFn = Apollo.MutationFunction<AddOfflineCardsToStockMutation, AddOfflineCardsToStockMutationVariables>;

/**
 * __useAddOfflineCardsToStockMutation__
 *
 * To run a mutation, you first call `useAddOfflineCardsToStockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddOfflineCardsToStockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addOfflineCardsToStockMutation, { data, loading, error }] = useAddOfflineCardsToStockMutation({
 *   variables: {
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useAddOfflineCardsToStockMutation(baseOptions?: Apollo.MutationHookOptions<AddOfflineCardsToStockMutation, AddOfflineCardsToStockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddOfflineCardsToStockMutation, AddOfflineCardsToStockMutationVariables>(AddOfflineCardsToStockDocument, options);
      }
export type AddOfflineCardsToStockMutationHookResult = ReturnType<typeof useAddOfflineCardsToStockMutation>;
export type AddOfflineCardsToStockMutationResult = Apollo.MutationResult<AddOfflineCardsToStockMutation>;
export type AddOfflineCardsToStockMutationOptions = Apollo.BaseMutationOptions<AddOfflineCardsToStockMutation, AddOfflineCardsToStockMutationVariables>;